export * from './kng-count-of-item-card.interface';
